import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAllProjects } from '../data/projectData';

const ProjectsPage = () => {
  const projects = getAllProjects();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white font-sans">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=80"
          alt="Our Projects"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-premium-dark/70 via-premium-dark/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-8 sm:p-16">
          <div className="max-w-7xl mx-auto">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
              Our Projects
            </h1>
            <p className="text-xl text-gray-200 max-w-2xl">
              Explore our portfolio of stunning residential and commercial projects
            </p>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <Link 
                key={project.id}
                to={`/project/${project.id}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg mb-4">
                  <img
                    src={project.heroImage}
                    alt={project.title}
                    className="w-full h-72 object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-premium-dark/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="inline-block bg-premium-gold/10 px-3 py-1 mb-2">
                  <span className="text-premium-dark text-sm font-medium">
                    {project.subtitle}
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-premium-dark group-hover:text-premium-gold transition-colors">
                  {project.title}
                </h3>
                <p className="text-gray-500 mt-2 line-clamp-2">
                  {project.overview}
                </p>
                <div className="flex items-center mt-4 text-premium-gold font-semibold">
                  View Project
                  <i className="fa-solid fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 bg-premium-light">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-premium-dark mb-4">
            Start Your Project
          </h2>
          <p className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto">
            Ready to transform your space? Let's discuss your vision and create something extraordinary together.
          </p>
          <button className="bg-premium-gold text-premium-dark px-10 py-5 text-lg font-bold hover:bg-premium-dark hover:text-white transition-colors">
            Book a free consultation
          </button>
          <div className="mt-6 text-gray-600">
            Or call us on <a href="tel:0403708601" className="text-premium-gold font-semibold hover:underline">0403708601</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsPage;
